import { useState } from "react";
import { Plus, Minus } from "lucide-react";

/**
 * PricingFAQ — 3-question FAQ snippet under the pricing tier cards.
 * Simple accordion, minimal chrome, mobile-first.
 */
const FAQS = [
  {
    q: "How do I cancel?",
    a: "Monthly members must give 30 days' written notice (one final monthly charge applies during that period), mailed to: The Farm To You, Canceling Department, PO Box 2, Oldsmar, FL 34677-0002, USA. Annual members can cancel anytime, but annual fees are non-refundable and are not prorated — your benefits stay active through the end of your paid year and then simply don't renew.",
  },
  {
    q: "When do I get charged?",
    a: "Immediately for the first period, then your membership renews automatically — monthly plans renew on the same day each month, and annual plans renew once a year on your original signup date.",
  },
  {
    q: "What if I miss a drop?",
    a: "No problem — membership is separate from drops. You keep your seat, all the perks, and just pick from the next drop. Every drop stays open until it sells out or its window closes.",
  },
];

function FaqItem({ q, a, isOpen, onToggle, testId }) {
  return (
    <div className="border-b border-[var(--ff-border)] last:border-b-0" data-testid={testId}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between text-left py-5 group"
        aria-expanded={isOpen}
        data-testid={`${testId}-toggle`}
      >
        <span className="font-display text-lg text-[var(--ff-primary)] group-hover:opacity-80 transition-opacity">
          {q}
        </span>
        <span className="ml-4 flex-shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-full bg-[var(--ff-muted)] text-[var(--ff-primary)]">
          {isOpen ? <Minus size={14}/> : <Plus size={14}/>}
        </span>
      </button>
      {isOpen && (
        <div className="pb-5 pr-11 text-[var(--ff-text-secondary)] leading-relaxed" data-testid={`${testId}-answer`}>
          {a}
        </div>
      )}
    </div>
  );
}

export default function PricingFAQ() {
  const [openIdx, setOpenIdx] = useState(-1);
  return (
    <section
      className="max-w-3xl mx-auto px-6 py-16"
      data-testid="pricing-faq-section"
      aria-labelledby="pricing-faq-heading"
    >
      <p className="overline text-[var(--ff-primary)] text-center">Quick answers</p>
      <h2
        id="pricing-faq-heading"
        className="font-display text-3xl sm:text-4xl mt-3 text-[var(--ff-primary)] leading-tight text-center"
      >
        The three questions we hear most.
      </h2>
      <div className="mt-10 bg-white rounded-2xl border border-[var(--ff-border)] px-6 sm:px-8">
        {FAQS.map((f, i) => (
          <FaqItem
            key={f.q}
            q={f.q}
            a={f.a}
            isOpen={openIdx === i}
            onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
            testId={`pricing-faq-item-${i}`}
          />
        ))}
      </div>
    </section>
  );
}
